import type { ApiError } from "@circle-react/config/CustomErrors";
import { useQuery } from "react-query";

import { accountSubscriptionApi } from "@/react/api/accountSubscriptionApi";

import type { CanDowngradeResponse } from "../types";

export const useCanDowngrade = (planId: number) => {
  const { data, error, isPending, isSuccess } = useQuery<
    CanDowngradeResponse,
    ApiError
  >({
    queryKey: ["canDowngrade", planId],
    queryFn: () => accountSubscriptionApi.canDowngrade(planId),
  });

  return {
    data,
    isPending,
    isSuccess,
    error,
  };
};
